/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Ambienttemperatureactualsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Ambient actual setpoint" |
*
* @param {Ahu_History_Key_Ambienttemperatureactualsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_ambienttemperatureactualsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Ambienttemperatureactualsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Ambienttemperatureactualsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient actual setpoint")
	return /** @type {LocalizedString} */ ("Consigne réelle d'ambiance")
});
export { ahu_history_key_ambienttemperatureactualsetpoint3 as "ahu_history_key_ambientTemperatureActualSetpoint" }